import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "expand__label" }
const _hoisted_2 = {
  key: 0,
  class: "icon-rotate"
}
const _hoisted_3 = {
  key: 1,
  class: "icon-rotate"
}
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { class: "text-primary icon-rotate" }

import {
  reactive,
  watch,
} from 'vue';

import Expansion from '@/components/Expansion.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Expand',
  props: {
  icon: {
    type: String,
    required: false,
    default: () => 'fa-light fa-chevron-down',
  },
  iconPosition: {
    type: String,
    required: false,
    default: () => 'left',
  },
  expanded: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  type: {
    type: String,
    required: false,
    default: () => 'default',
  },
  buttonClass: String,
  fontSize: String,
},
  emits: ['toggle'],
  setup(__props, { emit: __emit }) {

library.add(faChevronDown);

const emit = __emit;
const props = __props;

const component = reactive({
  expanded: props.expanded,
});

const toggle = () => {
  component.expanded = !component.expanded;
  emit('toggle', component.expanded);
};

emit('toggle', component.expanded);

watch(() => props.expanded, (val) => {
  component.expanded = val;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["expand", { 'expanded': component.expanded }])
  }, [
    _createElementVNode("button", {
      class: _normalizeClass({
          [__props.type]: true,
          [`font-size--${__props.fontSize}`]: !!__props.fontSize,
          [__props.buttonClass]: !!__props.buttonClass,
        }),
      onClick: toggle
    }, [
      (['default', 'bold'].includes(__props.type))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_1, [
              (__props.iconPosition === 'left')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: __props.icon }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _renderSlot(_ctx.$slots, "title")
              ]),
              (__props.iconPosition === 'right')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: __props.icon }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "hr_spacer" }, null, -1))
          ], 64))
        : _createCommentVNode("", true),
      (__props.type === 'small')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", _hoisted_4, [
              _renderSlot(_ctx.$slots, "title")
            ]),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_unref(FontAwesomeIcon), { icon: __props.icon }, null, 8, ["icon"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(Expansion, {
      expanded: component.expanded
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["expanded"])
  ], 2))
}
}

})